import { Controller } from "@hotwired/stimulus"

// Copies a text value to the clipboard and flashes "Copied!" feedback on an
// optional label target. Reusable — attach to any element:
//
//   data-controller="clipboard"
//   data-clipboard-text-value="..."
//   data-action="click->clipboard#copy"
//   <span data-clipboard-target="label">Copy</span>
export default class extends Controller {
  static values = { text: String }
  static targets = ["label"]

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => this.flashCopied())
  }

  flashCopied() {
    if (!this.hasLabelTarget) return

    const original = this.labelTarget.textContent
    this.labelTarget.textContent = "Copied!"
    setTimeout(() => {
      this.labelTarget.textContent = original
    }, 1200)
  }
}
